<template>
  <div class="instructor">
    <page-header />
    <audit-temp :audit_status="audit_status" :audit_remark="audit_remark" />
    <page-prompt />
    <section class="main">
      <h2 class="title">指导教师</h2>
      <div class="msgs">
        <el-button v-if="!inputDisabled" type="warning" icon="el-icon-document-copy" @click="onCopyLink"
          plain>点击此处复制链接分享给指导教师进行填写</el-button>
        <div class="teacher" v-for="item of instructor_list" :key="item.id">
          <div class="operate">
            <el-button v-if="!inputDisabled" type="success" icon="el-icon-edit-outline" size="mini"
              @click="onShowDialogForm(item)">排序</el-button>
            <el-button v-if="!inputDisabled" type="danger" icon="el-icon-delete" size="mini"
              @click="onDelInstructor(item.id)">删除</el-button>
          </div>
          <ul>
            <li>
              <label>姓名：</label>
              <span>{{ item.name }}</span>
            </li>
            <li>
              <label>队内排名</label>
              <span>{{ item.position }}</span>
            </li>
            <li>
              <label>身份证号：</label>
              <span>{{ item.identity }}</span>
            </li>
            <li>
              <label>性别：</label>
              <span>{{ sex_config_obj[item.sex] }}</span>
            </li>
            <li>
              <label>手机号：</label>
              <span>{{ item.phone }}</span>
            </li>
            <li>
              <label>电子邮箱：</label>
              <span>{{ item.email }}</span>
            </li>
            <li>
              <label>学校名称：</label>
              <span>{{ item.school_name }}</span>
            </li>
            <li>
              <label>学院名称：</label>
              <span>{{ item.college }}</span>
            </li>
            <li>
              <label>专业名称：</label>
              <span>{{ item.major }}</span>
            </li>
            <li>
              <label>职称：</label>
              <span>{{ item.professional }}</span>
            </li>
            <li>
              <label>工号：</label>
              <span>{{ item.work_id || '未填' }}</span>
            </li>
            <li>
              <label>入职年份：</label>
              <span>{{ item.dates || '未填' }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
        <el-button type="primary" icon="el-icon-right" @click="onNextPage">下一项</el-button>
      </div>
    </section>
    <el-dialog :fullscreen="true" title="成员信息" center :visible.sync="dialogFormVisible" :show-close="false">
      <div class="form">
        <el-form label-position="top">
          <el-form-item label="姓名" :required="true">
            <el-input v-model="ac_instructor.name" disabled />
          </el-form-item>
          <el-form-item label="队内排名" :required="true">
            <el-input-number v-model="ac_instructor.position" :step="1" :min="1" :max="5"
              step-strictly></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancelInstructor">取 消</el-button>
        <el-button type="primary" @click="onConfirmInstructor">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AuditTemp from '@/components/AuditTemp'
import PagePrompt from '@/components/PagePrompt'
import { fetchInstructorList, delInstructorItem, setInstructorItem } from '@/service/api'

export default {
  name: 'PageInstructor',
  components: {
    PageHeader,
    AuditTemp,
    PagePrompt
  },
  data () {
    return {
      reg_code: '',
      audit_status: 3,
      audit_remark: '',
      reg_preliminary_expire: false,
      sex_config_obj: {
        1: '男',
        2: '女'
      },
      instructor_list: [],
      ac_instructor: {},
      dialogFormVisible: false
    }
  },
  computed: {
    inputDisabled () {
      return this.audit_status === 2 || this.audit_status === 4 || this.audit_status === 5 || this.reg_preliminary_expire
    }
  },
  methods: {
    onPrevPage () {
      this.$router.push('/team')
    },
    onNextPage () {
      this.$router.push('/works')
    },
    onCopyLink () {
      const url = `http://bzyspgc.caams.org.cn/index/registration/main/instructor?reg_code=${this.reg_code}#/login`
      this.$copyText(url).then((e) => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      }, (e) => {
        this.$message.error('复制失败')
      })
    },
    async getInstructorList () {
      try {
        const data = await fetchInstructorList()
        this.reg_preliminary_expire = data.reg_preliminary_expire
        this.instructor_list = data.reg_instructor_list
        this.audit_status = data.reg_team_basic.audit_status
        this.audit_remark = data.reg_team_basic.audit_remark
        this.reg_code = data.reg_team_basic.code
      } catch (error) {
        console.log('getInstructorList error', error)
      }
    },
    onDelInstructor (id) {
      this.$confirm('是否继续删除，删除后不可恢复? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        async () => {
          try {
            const loading = this.$loading({
              lock: true,
              text: '删除中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.8)'
            })
            await delInstructorItem({ id })
            loading.close()
            this.getInstructorList()
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
          } catch (error) {
            console.log('error:', error)
          }
        }
      ).catch(
        () => {
          console.log('取消删除')
        }
      )
    },
    onShowDialogForm (item) {
      this.dialogFormVisible = true
      this.ac_instructor = item
    },
    async onConfirmInstructor () {
      if (!this.ac_instructor.position) {
        this.$alert(`请填写队内排名`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })

      try {
        await setInstructorItem(this.ac_instructor)
        loading.close()
        this.getInstructorList()
        this.onCancelInstructor()
      } catch (error) {
        loading.close()
        console.log('onConfirmInstructor error', error)
        this.$alert(error, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    onCancelInstructor () {
      this.dialogFormVisible = false
      this.ac_instructor = {}
      this.getInstructorList()
    }
  },
  mounted () {
    document.body.style.height = 'auto'
    this.getInstructorList()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
